namespace Gamification.Gamification {
    export interface ApiScriptOperazioniForm {
        IdApi: Serenity.LookupEditor;
        IdProdotto: Serenity.LookupEditor;
        PunteggiTipoOperazione: Serenity.EnumEditor;
        PunteggiValore: Serenity.IntegerEditor;
        CreditiTipoOperazione: Serenity.EnumEditor;
        CreditiValore: Serenity.IntegerEditor;
        ExpValore: Serenity.IntegerEditor;
        IdProdottoBadge: Serenity.LookupEditor;
        BadgeNome: Serenity.BooleanEditor;
        BadgeDescrizione: Serenity.BooleanEditor;
        BadgeImmagine: Serenity.BooleanEditor;
        IdProdottoEsperienza: Serenity.LookupEditor;
        EsperienzaNome: Serenity.BooleanEditor;
        EsperienzaDescrizione: Serenity.BooleanEditor;
        EsperienzaClassi: Serenity.BooleanEditor;
        EsperienzaMigliorPunteggio: Serenity.BooleanEditor;
        EsperienzaPeggiorPunteggio: Serenity.BooleanEditor;
        EsperienzaUltimoPunteggio: Serenity.BooleanEditor;
        IdProdottoEsperienzaPerPunteggioEsperienza: Serenity.LookupEditor;
        PunteggioEsperienzaInfluenzaPunteggioGlobale: Serenity.BooleanEditor;
        PunteggioEsperienzaAzione: Serenity.EnumEditor;
        PunteggioEsperienzaValore: Serenity.IntegerEditor;
        IdProdottoEsperienzaPerUltimoPunteggioEsperienza: Serenity.LookupEditor;
        UltimoPunteggioEsperienzaValore: Serenity.IntegerEditor;
        IdProdottoEsperienzaForTask: Serenity.LookupEditor;
        IdProdottoEsperienzaTask: Serenity.LookupEditor;
        TaskNome: Serenity.BooleanEditor;
        TaskDescrizione: Serenity.BooleanEditor;
        TaskStatus: Serenity.BooleanEditor;
    }

    export class ApiScriptOperazioniForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiScriptOperazioni';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiScriptOperazioniForm.init)  {
                ApiScriptOperazioniForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ApiScriptOperazioniForm, [
                    'IdApi', w0,
                    'IdProdotto', w0,
                    'PunteggiTipoOperazione', w1,
                    'PunteggiValore', w2,
                    'CreditiTipoOperazione', w1,
                    'CreditiValore', w2,
                    'ExpValore', w2,
                    'IdProdottoBadge', w0,
                    'BadgeNome', w3,
                    'BadgeDescrizione', w3,
                    'BadgeImmagine', w3,
                    'IdProdottoEsperienza', w0,
                    'EsperienzaNome', w3,
                    'EsperienzaDescrizione', w3,
                    'EsperienzaClassi', w3,
                    'EsperienzaMigliorPunteggio', w3,
                    'EsperienzaPeggiorPunteggio', w3,
                    'EsperienzaUltimoPunteggio', w3,
                    'IdProdottoEsperienzaPerPunteggioEsperienza', w0,
                    'PunteggioEsperienzaInfluenzaPunteggioGlobale', w3,
                    'PunteggioEsperienzaAzione', w1,
                    'PunteggioEsperienzaValore', w2,
                    'IdProdottoEsperienzaPerUltimoPunteggioEsperienza', w0,
                    'UltimoPunteggioEsperienzaValore', w2,
                    'IdProdottoEsperienzaForTask', w0,
                    'IdProdottoEsperienzaTask', w0,
                    'TaskNome', w3,
                    'TaskDescrizione', w3,
                    'TaskStatus', w3
                ]);
            }
        }
    }
}
